import type { FC } from "react";

import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

const StyledEmptyState = styled(EmptyState)<{ height?: number }>`
    height: ${({ height }) => (height ? `calc(${height} - 24px)` : "auto")};
`;

interface NoDataEmptyStateProps {
    title?: string;
    subtitle?: string;
    isError?: boolean;
    height?: number;
}

const NoDataEmptyState: FC<NoDataEmptyStateProps> = ({ title, subtitle, isError, height }) => {
    const fallbackSubtitleKey = isError ? "websiteKeywords.loading.data.banner.error" : "global.nodata.notavilable";

    return (
        <StyledEmptyState
            title={translate(title ?? "")}
            subtitle={translate(subtitle ?? fallbackSubtitleKey)}
            height={height}
        />
    );
};

export default NoDataEmptyState;
